
export class DataStandardsContent {

    constructor() {
        $(".expand-all").on("click", () => {
            $(".crf-table").css("display", "table");
            $(".collapse-all").css("display", "block");
            $(".expand-all").css("display", "none");
            $(".fa-circle-plus").css("display", "none");
            $(".fa-circle-minus").css("display", "inline-block");

            $(".crf-table-caption").addClass("crf-table-showing");
        });


        $(".collapse-all").on("click", () => {
            $(".crf-table").css("display", "none");
            $(".collapse-all").css("display", "none");
            $(".expand-all").css("display", "block");
            $(".fa-circle-plus").css("display", "inline-block");
            $(".fa-circle-minus").css("display", "none");

            $(".crf-table-caption").removeClass("crf-table-showing");
        });


        $(".crf-table-container").each((idx, element) => {
            const caption = $(element).find(".crf-table-caption");
            const table = $(element).find(".crf-table");

            caption.on("click", () => {
            const showBtn = caption.find(".fa-circle-plus");
            const hideBtn = caption.find(".fa-circle-minus")

                if (caption.hasClass("crf-table-showing")) {
                    table.css("display", "none");
                    showBtn.css("display", "inline-block");
                    hideBtn.css("display", "none");
                    caption.removeClass("crf-table-showing");
                } else {
                    table.css("display", "table");
                    hideBtn.css("display", "inline-block");
                    showBtn.css("display", "none");
                    caption.addClass("crf-table-showing");
                }
            });
        });

        $('.cde-details').on('click', (evt, ) => {
            const cdeVal = $(evt.currentTarget).data('cde');
            if (cdeVal) {
                const cdeTitle = $(evt.currentTarget).data('cdeTitle') || '';
                const tbody = $('#cde-modal-table-body');

                $('#cde-details-modal-title').text(cdeTitle);

                $.getJSON(`/system/cde-json/${cdeVal}.json`, (data) => {

                    const bodyContent = data.map((el) =>
                        `<tr>
                            <td>${el['CDE ID']}</td>
                            <td>${el['CDE Name']}</td>
                            <td>${el['Population']}</td>
                            <td>${el['Classification (e.g., Core)']}</td>
                            <td>${el['CRF Module / Guideline'] || el['CRF Module/Guideline']}</td>
                            <td>${el['Sub Domain Name']}</td>
                            <td>${el['Domain Name']}</td>
                        </tr>`);

                    tbody.html(bodyContent.join(''));

                    $('#cde-download-button').attr('href', `/system/cde-xlsx/${cdeVal}.xlsx`);
                    $('#cde-download-button').attr('download', `${cdeVal}.xlsx`);

                    $('#cde-details-modal').modal('show');
                });
            }

            evt.stopPropagation();
        });

        $('#cde-details-modal-close').on('click', () => {
            $('#cde-details-modal').modal('hide');
        });
    }
}